import { render, staticRenderFns } from "./WebhookVietguysList.vue?vue&type=template&id=695b44ee"
import script from "./WebhookVietguysList.vue?vue&type=script&lang=js"
export * from "./WebhookVietguysList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports